import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Route, Redirect, Switch } from 'react-router-dom';
import Dashboard from "./Pages/Dashboard/Dashboard";
import Timecards from "./Pages/Timecards/Timecards";
import Adjustments from "./Pages/Adjustments/Adjustments";
import Login from "./Pages/Login/Signin/Login";
import SelectedReports from "./Pages/SelectedReports/SelectedReports";
import Audit from "./Pages/Audit/Audit";
import { Provider } from "react-redux";
import store from "./redux/store";
import Masterfile from "./Pages/MasterFile/MasterFile";
import Cookies from "js-cookie";
import AdminDash from "./Pages/Dashboard/AdminDash";
import Utilities from "./Pages/Utilities/Utilities";
import PreviewReview from "./Pages/PreviewReview/PreviewReview";
import PayrollChecklist from "./Pages/PayrollChecklist/PayrollChecklist";
import PayrollHours from "./Pages/PayrollHoursAudit/PayrollHours";
import ActivityLog from "./Pages/ActivityLog/ActivityLog";
import UserManagementPage from "./Pages/UserManagement/UserManagement";
import updatecredentialGrid from "./Pages/UpdateCredentialsGrid/updateCredentialsGrid";
import Moniter from "./Pages/Moniter/Moniter";
import HealthInsurance from "./Pages/HealthInsurance/HealthInsurance";
import { AdminRoute, UserRoute, TimecardFollowupRoute } from "./Auth/ProtectedRoutes";
import Garnishments from "./Pages/Garnishments/Garnishments";
import NewHires from "./Pages/NewHires/NewHires";
import OffCyclePage from "./Pages/OffCycle/OffCycle";
import ContingentExpenseManagement from "./Pages/ExpenseManagement/ContingentExpense";
import CorporateExpenseManagement from "./Pages/ExpenseManagement/CorporateExpense";
import ExpenseManagement from "./Pages/ExpenseManagement/ExpenseMain";
import GlCodes from "./Components/ExpenseManagement/GlCodes";
import Graph from "./Pages/Analytics (File Upload)/Graphs"
import AnalyticsGraphs from "./Pages/Analytics2/Graph";
import FinalMasterAudit from "./Pages/FinalMasterAudit/FinalMasterAudit";
import TimesheetTeam from "./Pages/TimecardFollowup/TimesheetTeam";
import ClientServices from "./Pages/TimecardFollowup/ClientServices";
import EmployeeCare from "./Pages/TimecardFollowup/EmployeeCare";
import CalendarView from "./Pages/CalenderView/CalendarView";
import StatutoryReporting from "./Pages/StatutoryReporting/StatutoryReporting";
import UtilitiesNew from "./Pages/Utilities/NewUtilities";
import MainUtilities from "./Pages/Utilities/NewUtilities";
import PRReports from "./Pages/PRReports/PRReportAmgen";
import Billing from "./Pages/Billing/Billing";
import ReportingTable from "./Pages/StatutoryReporting/ReportingTable";
import PaidBilled from "./Pages/StatutoryReporting/PaidBilled";
import SendOtp from "./Pages/Login/Signin/SendOtp";
import VerificationForm from "./Pages/Login/Signin/VerifyEmail";
import resetPassword from "./Pages/Login/ResetPassword/Reset";
import Verification from "./Pages/Login/ResetPassword/verifyOtp";
import ResetPassword from "./Pages/Login/ResetPassword/NewPassowordConfirm";
import TimecardCrawl from "./Pages/TimecardFollowup/TimecardCrawl";
import TenNinetyNine from "./Pages/1099/1099";
import TenNinetyNineMasterfile from "./Pages/1099/1099Masterfile";
import BillingCrawl from "./Pages/Billing/BillingCrawl";
import TenNinetyNineCrawl from "./Pages/1099/1099Crawling";
import PRReportsHomePage from "./Pages/PRReports/PRReportsHomePage";
import PRReportBMS from "./Pages/PRReports/PRReportBMS";
import PRReportAbbott from "./Pages/PRReports/PRReportAbbott";
import PRReportIntegra from "./Pages/PRReports/PRReportIntegra";
import PRHPE from "./Pages/PRReports/PRReportHPE";
import BillingMasterfile from "./Pages/Billing/BillingMasterfile";
import BillingInvoiceUploadFile from "./Pages/Billing/BillingInvoiceUploadFile";
import CanadaCrawl from "./Pages/Canadapayroll/CanadaCrawl";
import CanadaMasterfile from "./Pages/Canadapayroll/CanadaMasterfile";
import ConsolidatedData from "./Pages/Canadapayroll/ConsolidatedData";
import Canada_Autocrawl from "./Components/CanadaPayroll/CanadaAutoCrawl";
import { BaseUrl, JsonConfig } from "./Repository/BaseRepository";
import axios from "axios";
import ExpensesCrawl from "./Pages/ExpensesModule/ExpensesCrawl";
import Expenses_Autocrawl from "./Pages/ExpensesModule/ExpensesAutocrawl";
import ExpensesMasterfile from "./Pages/ExpensesModule/ExpensesMasterfile";
import PRReportsMultiClients from "./Pages/PRReports/PRReportTotalEnergies";
import AccrualsCrawling from "./Pages/Accruals/AccrualsCrawling";


const ProjectRoutes = () => {

  useEffect(() => {
    const onBeforeUnload = (event) => {
      const url = `${BaseUrl}Auth/logout`;
  
      // Prepare logout data
      const logoutData = JSON.stringify(JsonConfig);
  
      // Send the request using sendBeacon
      navigator.sendBeacon(url, logoutData);
  
      // Delay cookie removal to ensure API request is processed
      setTimeout(() => {
        Cookies.remove("jwt_token");
        Cookies.remove("UserLogin");
        Cookies.remove("first_name");
        Cookies.remove("last_name");
        Cookies.remove("Role");
        Cookies.remove("Date");
        Cookies.remove("tenant_name");
      }, 500); 
    };
  
    window.addEventListener("unload", onBeforeUnload);
  
    return () => {
      window.removeEventListener("unload", onBeforeUnload);
    };
  }, []);
  

  return (
    <div style={{ height: "100%", width: "100%" }}>
      <Router forceRefresh={true}>
        <Provider store={store}>
          <Switch>
            <UserRoute exact path="/:user/dashboard" component={Dashboard} />
            <AdminRoute
              exact
              path="/:admin/admin-dashboard"
              component={AdminDash}
            />
            <Route
              exact
              path='/:tmshteam/timesheetteam'
              component={TimesheetTeam}
            />
            <Route
              exact
              path='/:clientserve/clientservices'
              component={ClientServices}
            />
            <Route
              exact
              path='/:empcare/employeecare'
              component={EmployeeCare}
            />
            <Route
              exact
              path='/:timecardcrawl/timecardfollowupcrawling'
              component={TimecardCrawl}
            />
            <UserRoute exact path="/:timecards/timecards" component={Timecards} />
            <Route exact path="/:otp/sendotp" component={SendOtp} />
            <Route exact path="/:mail/verifymail" component={VerificationForm} />
            <Route exact path="/reset" component={resetPassword} />
            <Route exact path="/verifyotp" component={Verification} />
            <Route exact path="/passwordconfirmation" component={ResetPassword} />
            <UserRoute exact path="/:adj/adjustments" component={Adjustments} />
            <UserRoute exact path="/:msf/masterfile" component={Masterfile} />
            <UserRoute exact path="/:audit/audit" component={Audit} />
            <UserRoute exact path="/:selected/selectedreports" component={SelectedReports} />
            <UserRoute exact path="/:util/utilities" component={MainUtilities} />
            <UserRoute exact path="/:prev/preview" component={PreviewReview} />
            <UserRoute exact path="/:check/payrollchecklist" component={PayrollChecklist} />
            <UserRoute exact path="/:hoursaudit/payrollhoursaudit" component={PayrollHours} />
            <UserRoute exact path="/:acts/activitylog" component={ActivityLog} />
            <UserRoute exact path="/:health/healthinsurance" component={HealthInsurance} />
            <UserRoute exact path="/:creds/updatecredentialGrid" component={updatecredentialGrid} />
            <UserRoute exact path="/:garnsh/garnishments" component={Garnishments} />
            <UserRoute exact path="/:masteraudit/finalmasteraudit" component={FinalMasterAudit} />
            <UserRoute exact path="/:newhire/newhiresrehires" component={NewHires} />
            <UserRoute exact path="/:offcycl/offcycle" component={OffCyclePage} />
            <UserRoute exact path="/:mntr/moniter" component={Moniter} />
            <UserRoute exact path="/:strp/statutoryreporting" component={StatutoryReporting} />
            <UserRoute exact path="/:prrpts/prreports" component={PRReports} />
            <UserRoute exact path="/:bms/prreportbms" component={PRReportBMS} />
            <UserRoute exact path="/:abbott/prreportabbott" component={PRReportAbbott} />
            <UserRoute exact path="/:integra/prreportintegra" component={PRReportIntegra} />
            <UserRoute exact path="/:hpe/prreporthpe" component={PRHPE} />
            <UserRoute exact path="/:pr/prreportshomepage" component={PRReportsHomePage} />
            <UserRoute exact path="/:pr/prreportsmulticlients" component={PRReportsMultiClients} />
           
            <Route exact path="/:bill/billing" component={Billing} />
            <Route exact path="/:billcrawl/billingcrawling" component={BillingCrawl} />
            <Route exact path="/:billmf/billingmasterfile" component={BillingMasterfile} />
            <Route exact path="/:billupload/billinginvoiceuploadfile" component={BillingInvoiceUploadFile} />
            <UserRoute exact path="/:reptbl/reportingtable" component={ReportingTable} />
            <UserRoute exact path='/:pdvsbld/paidvsbilled' component={PaidBilled} />
            <AdminRoute
              exact
              path="/:usermgmt/usermanagement"
              component={UserManagementPage}
            />
            <UserRoute exact path="/:contingent/contingentexpensemanagement" component={ContingentExpenseManagement} />
            <UserRoute exact path="/:corporate/corporateexpensemanagement" component={CorporateExpenseManagement} />
            <UserRoute exact path="/:expnse/expensemanagement" component={ExpenseManagement} />
            <UserRoute exact path="/:glc/glcodes" component={GlCodes} />
            <UserRoute exact path="/:anlyts/analytics" component={Graph} />
            <UserRoute exact path="/:calen/calendarview" component={CalendarView} />
            <Route exact path="/:ten/1099" component={TenNinetyNine} />
            <Route exact path="/:tenmf/1099masterfile" component={TenNinetyNineMasterfile} />
            <Route exact path="/:tencrawl/1099crawl" component={TenNinetyNineCrawl} />
            <UserRoute exact path="/:candacrawl/canadaautocrawl" component={Canada_Autocrawl} />
            <UserRoute exact path="/:expensescrawl/expensescrawl" component={ExpensesCrawl} />
            <UserRoute exact path="/:expensesautocrawl/expensesautocrawl" component={Expenses_Autocrawl} />
            <UserRoute exact path="/:candacons/consolidateddata" component={CanadaMasterfile} />
            <UserRoute exact path="/:canadamf/canadamasterfile" component={ConsolidatedData} />
            <UserRoute exact path="/:canada/canadapayroll" component={CanadaCrawl} />
            <UserRoute exact path="/:anlts/Analytics 2" component={AnalyticsGraphs} />
            <UserRoute exact path="/:expensesmasterfile/expensesmasterfile" component={ExpensesMasterfile} />
            <UserRoute exact path="/:accrualscrawling/accrualscrawling" component={AccrualsCrawling} />
            <Route exact path="/:id" component={Login} />
          </Switch>
        </Provider>
      </Router>
    </div>
  );
};
export default ProjectRoutes;